import Highcharts from 'highcharts';

const MODERN_COLORS = [
  '#6366f1', // indigo
  '#f59e0b', // amber
  '#10b981', // emerald
  '#ef4444', // red
  '#3b82f6', // blue
  '#8b5cf6', // violet
  '#14b8a6', // teal
  '#f97316', // orange
  '#ec4899', // pink
  '#06b6d4', // cyan
];

const FONT_FAMILY =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

const modernTheme: Highcharts.Options = {
  colors: MODERN_COLORS,

  chart: {
    backgroundColor: 'transparent',
    style: { fontFamily: FONT_FAMILY },
    spacing: [16, 16, 16, 16],
    animation: { duration: 500 },
  },

  title: {
    style: {
      color: '#1e293b',
      fontSize: '16px',
      fontWeight: '600',
    },
  },

  subtitle: {
    style: {
      color: '#64748b',
      fontSize: '13px',
      fontWeight: '400',
    },
  },

  xAxis: {
    gridLineColor: '#e2e8f0',
    gridLineWidth: 0,
    lineColor: '#e2e8f0',
    tickColor: '#e2e8f0',
    labels: {
      style: { color: '#64748b', fontSize: '11px' },
    },
    title: {
      style: { color: '#475569', fontSize: '12px', fontWeight: '500' },
    },
  },

  yAxis: {
    gridLineColor: '#f1f5f9',
    gridLineDashStyle: 'Dash',
    lineColor: '#e2e8f0',
    lineWidth: 0,
    tickColor: '#e2e8f0',
    labels: {
      style: { color: '#64748b', fontSize: '11px' },
    },
    title: {
      style: { color: '#475569', fontSize: '12px', fontWeight: '500' },
    },
  },

  legend: {
    backgroundColor: 'transparent',
    itemStyle: {
      color: '#475569',
      fontSize: '12px',
      fontWeight: '400',
    },
    itemHoverStyle: { color: '#1e293b' },
    itemHiddenStyle: { color: '#cbd5e1' },
    symbolRadius: 4,
  },

  tooltip: {
    backgroundColor: 'rgba(15, 23, 42, 0.92)',
    borderWidth: 0,
    borderRadius: 8,
    shadow: true,
    style: {
      color: '#f8fafc',
      fontSize: '12px',
    },
    padding: 10,
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      animation: { duration: 600 },
      states: {
        hover: { brightness: 0.05 },
        inactive: { opacity: 0.4 },
      },
    },
    area: {
      fillOpacity: 0.15,
      lineWidth: 2,
      marker: { radius: 3, symbol: 'circle' },
    },
    spline: {
      lineWidth: 2.5,
      marker: { radius: 3, symbol: 'circle' },
    },
    line: {
      lineWidth: 2.5,
      marker: { radius: 3, symbol: 'circle' },
    },
    column: {
      borderRadius: 4,
      borderWidth: 0,
    },
    bar: {
      borderRadius: 4,
      borderWidth: 0,
    },
    pie: {
      borderWidth: 0,
      dataLabels: {
        style: { fontSize: '12px', fontWeight: '400', color: '#475569' },
      },
    },
  },

  credits: { enabled: false },

  drilldown: {
    activeAxisLabelStyle: {
      color: '#475569',
      textDecoration: 'none',
    },
  },

  navigation: {
    buttonOptions: {
      symbolStroke: '#64748b',
      theme: { fill: 'transparent' },
    },
  },
};

export const applyModernTheme = (): void => {
  Highcharts.setOptions(modernTheme);
};

export { MODERN_COLORS, FONT_FAMILY };
export default modernTheme;
